<template>
  <section
    ref="core_business"
    class="pi-flex-column-center pi-pd-top-84 pi-pd-bottom-55 pi-w-100vw"
  >
    <div
      ref="core_business_txt"
      class="core_business_txt"
      :class="isMobile||show ? 'animate__animated animate__fadeInDown' : 'hide'"
    >
      <div
        class="pi-fz-30 pi-fw-900 pi-pd-bottom-29 pi-pd-lr-24"
        style="color: #222"
      >
        核心业务·助力企业数字化转型
      </div>
      <div class="pi-fz-16 pi-fw-400 pi-pd-lr-24">
        APJ作为粤港澳大湾区领先的数字化转型服务提供商，在包括大数据、云计算、物联网等“数字科技”应用上极具竞争力，并运用“数字科技”助力企业实现数字化转型，持续为客户创造竞争优势。
      </div>
    </div>
  </section>
</template>

<script>
import { isMobile } from "@/utils";
export default {
  data() {
    return {
      isMobile: isMobile(),
      img_show: false,
    };
  },
  methods: {
    loadInit(){
      return this.$refs.core_business
    }
  },
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.hide{
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/core_business/index.vue